/**-----------------------------------------------------------------------------------------
* Copyright © 2023 Progress Software Corporation. All rights reserved.
* Licensed under commercial license. See LICENSE.md in the package root for more information
*-------------------------------------------------------------------------------------------*/
"use client";
import * as l from "react";
import { guid as ie, classNames as F, IconWrap as B, getActiveElement as de, Keys as y, canUseDOM as Be, validatePackage as pe, getTabIndex as ue } from "@progress/kendo-react-common";
import { ProgressBar as he } from "@progress/kendo-react-progressbars";
import { provideLocalizationService as x, registerForLocalization as U, IntlService as Te, useLocalization as ze } from "@progress/kendo-react-intl";
import { Button as j } from "@progress/kendo-react-buttons";
import { arrowRotateCwSmallIcon as Me, cancelIcon as Le, xIcon as He, fileIcon as je, fileZipIcon as Pe, fileConfigIcon as Ve, fileProgrammingIcon as Ke, fileDataIcon as Ge, filePresentationIcon as Ze, filePdfIcon as $e, fileTxtIcon as qe, fileVideoIcon as Xe, fileAudioIcon as We, fileImageIcon as Je, copyIcon as Qe, checkIcon as Ye, exclamationCircleIcon as et, uploadIcon as me } from "@progress/kendo-svg-icons";
import c from "prop-types";
import L from "axios";
var u = /* @__PURE__ */ ((n) => (n[n.UploadFailed = 0] = "UploadFailed", n[n.Initial = 1] = "Initial", n[n.Selected = 2] = "Selected", n[n.Uploading = 3] = "Uploading", n[n.Uploaded = 4] = "Uploaded", n[n.RemoveFailed = 5] = "RemoveFailed", n[n.Removing = 6] = "Removing", n))(u || {});
const P = "upload.cancel", V = "upload.clearSelectedFiles", K = "upload.dropFilesHere", G = "upload.headerStatusUploaded", Z = "upload.headerStatusUploading", tt = "upload.invalidFileExtension", st = "upload.invalidFiles", ot = "upload.invalidMaxFileSize", nt = "upload.invalidMinFileSize", $ = "upload.remove", q = "upload.retry", w = "upload.select", fe = "upload.selectTitle", ge = "upload.selectNoFilesTitle", X = "upload.uploadSelectedFiles", W = "upload.total", J = "upload.files", N = "upload.statusUploaded", O = "upload.statusUploadFailed", Q = "upload.dropZoneHint", Y = "upload.defaultDropZoneNote", ee = "upload.dropZoneNote", g = {
  [P]: "Cancel",
  [V]: "Clear",
  [K]: "Drop files here to upload",
  [G]: "Done",
  [Z]: "Uploading...",
  [tt]: "File type not allowed.",
  [st]: "Invalid file(s). Please check file upload requirements.",
  [ot]: "File size too large.",
  [nt]: "File size too small.",
  [$]: "Remove",
  [q]: "Retry",
  [w]: "Select files...",
  [fe]: "Press to select more files",
  [ge]: "No files selected",
  [X]: "Upload",
  [W]: "Total",
  [J]: "files",
  [N]: "File(s) successfully uploaded.",
  [O]: "File(s) failed to upload.",
  [Q]: "Drag and drop files here to upload.",
  [Y]: "",
  [ee]: "Only {0} files are allowed."
}, it = /&/g, at = /</g, lt = /"/g, rt = /'/g, ct = />/g, ve = (n) => ("" + n).replace(it, "&amp;").replace(at, "&lt;").replace(ct, "&gt;").replace(lt, "&quot;").replace(rt, "&#39;"), Ee = (n) => {
  const e = /\.([^\.]+)$/, t = n.match(e);
  return t ? t[0] : "";
}, Fe = (n) => {
  const e = n.name, t = n.size;
  return {
    extension: Ee(e),
    name: ve(e),
    getRawFile: () => n,
    size: t,
    status: u.Selected,
    progress: 0,
    uid: ""
  };
}, dt = (n) => {
  let e = new Array(), t;
  for (t = 0; t < n.length; t++)
    e.push(Fe(n[t]));
  return e;
}, te = (n) => !!(n.validationErrors && n.validationErrors.length > 0), pt = (n) => {
  for (let e of n)
    if (te(e))
      return !0;
  return !1;
}, ut = (n) => {
  let e = 0, t;
  if (typeof n[0].size == "number")
    for (t = 0; t < n.length; t++)
      n[t].size && (e += n[t].size || 0);
  else
    return "";
  return e /= 1024, e < 1024 ? e.toFixed(2) + " KB" : (e / 1024).toFixed(2) + " MB";
}, ht = (n, e) => {
  const t = ie();
  return n.map((s) => (s.uid = e ? t : ie(), s));
}, mt = (n) => {
  let e = !1, t = !1, s = !1, o = !1;
  const i = (a) => {
    a.forEach((r) => {
      r.status === u.Uploading && (e = !0), r.status === u.Uploaded && (t = !0), r.status === u.UploadFailed && (s = !0), te(r) && (o = !0);
    });
  };
  return Array.isArray(n) ? i(n) : Object.keys(n).forEach((a) => {
    i(n[a]);
  }), [e, t, s, o];
}, I = {
  fileHasValidationErrors: te,
  filesHaveValidationErrors: pt,
  getTotalFilesSizeMessage: ut,
  getAllFileInfo: dt,
  getFileInfo: Fe,
  getFileExtension: Ee,
  htmlEncode: ve,
  assignGuidToFiles: ht,
  getFileStatus: mt
};
class se extends l.Component {
  constructor(e) {
    super(e), this.buttonClassNames = (t) => {
      const { actionFocused: s, retryFocused: o } = this.state;
      return F(
        "k-icon-button k-upload-action",
        this.props.disabled ? "k-disabled" : "",
        s && t === "action" || o && t === "retry" ? "k-focus" : ""
      );
    }, this.onRetryFocus = () => {
      this.setState({
        retryFocused: !0
      });
    }, this.onRetryBlur = () => {
      this.setState({
        retryFocused: !1
      });
    }, this.onActionFocus = () => {
      this.setState({
        actionFocused: !0
      });
    }, this.onActionBlur = () => {
      this.setState({
        actionFocused: !1
      });
    }, this.onActionClick = () => {
      const { status: t, uid: s, disabled: o, onCancel: i, onRemove: a } = this.props;
      o || t === u.Removing || (t === u.Uploading ? i.call(void 0, s) : a.call(void 0, s));
    }, this.onRetryClick = () => {
      const { uid: t, disabled: s, onRetry: o } = this.props;
      s || o.call(void 0, t);
    }, this.state = {
      retryFocused: !1,
      actionFocused: !1
    };
  }
  actionButtonTitle(e, t) {
    return e === u.Uploading ? t.toLanguageString(P, g[P]) : t.toLanguageString($, g[$]);
  }
  retryButtonTitle(e) {
    return e.toLanguageString(q, g[q]);
  }
  render() {
    const { status: e, progress: t } = this.props, s = e === u.UploadFailed, o = e === u.Uploading, i = (e === u.Uploaded || e === u.Initial) && !this.props.async.removeUrl, a = x(this), r = "%";
    return /* @__PURE__ */ l.createElement("span", { className: "k-upload-actions" }, o ? /* @__PURE__ */ l.createElement("span", { className: "k-upload-pct" }, t, r) : void 0, s ? /* @__PURE__ */ l.createElement(
      j,
      {
        type: "button",
        themeColor: "base",
        fillMode: "flat",
        tabIndex: -1,
        className: this.buttonClassNames("retry"),
        onFocus: this.onRetryFocus,
        onBlur: this.onRetryBlur,
        onClick: this.onRetryClick,
        "aria-label": this.retryButtonTitle(a),
        title: this.retryButtonTitle(a),
        icon: "arrow-rotate-cw-small",
        svgIcon: Me
      }
    ) : void 0, i ? void 0 : /* @__PURE__ */ l.createElement(
      j,
      {
        type: "button",
        themeColor: "base",
        fillMode: "flat",
        tabIndex: -1,
        className: this.buttonClassNames("action"),
        onFocus: this.onActionFocus,
        onBlur: this.onActionBlur,
        onClick: this.onActionClick,
        "aria-label": this.actionButtonTitle(e, a),
        title: this.actionButtonTitle(e, a),
        icon: e === u.Uploading ? "cancel" : "x",
        svgIcon: e === u.Uploading ? Le : He
      }
    ));
  }
}
U(se);
class Ce extends l.Component {
  /**
   * @hidden
   */
  getFileExtension(e) {
    return e.extension ? e.extension.substring(1) : "";
  }
  /**
   * @hidden
   */
  getFileValidationMessage(e, t) {
    const s = x(this);
    let o = "";
    if (t)
      o = s.toLanguageString(O, g[O]);
    else if (e.validationErrors && e.validationErrors.length > 0) {
      const i = `upload.${e.validationErrors[0]}`;
      o = s.toLanguageString(i, g[i]);
    }
    return o;
  }
  /**
   * @hidden
   */
  getFileExtensionIcon(e) {
    switch (e.extension) {
      case ".png":
      case ".jpg":
      case ".jpeg":
      case ".tiff":
      case ".bmp":
      case ".gif":
        return { name: "file-image", icon: Je };
      case ".mp3":
      case ".mp4":
      case ".wav":
        return { name: "file-audio", icon: We };
      case ".mkv":
      case ".webm":
      case ".flv":
      case ".gifv":
      case ".avi":
      case ".wmv":
        return { name: "file-video", icon: Xe };
      case ".txt":
        return { name: "file-txt", icon: qe };
      case ".pdf":
        return { name: "file-pdf", icon: $e };
      case ".ppt":
      case ".pptx":
        return { name: "file-presentation", icon: Ze };
      case ".csv":
      case ".xls":
      case ".xlsx":
        return { name: "file-data", icon: Ge };
      case ".html":
      case ".css":
      case ".js":
      case ".ts":
        return { name: "file-programming", icon: Ke };
      case ".exe":
        return { name: "file-config", icon: Ve };
      case ".zip":
      case ".rar":
        return { name: "file-zip", icon: Pe };
      default:
        return { name: "file", icon: je };
    }
  }
  /**
   * @hidden
   */
  renderValidationError(e, t) {
    return /* @__PURE__ */ l.createElement("span", { className: "k-file-info", key: "2" }, /* @__PURE__ */ l.createElement("span", { className: "k-file-name", title: e.name }, e.name), /* @__PURE__ */ l.createElement("span", { className: "k-file-validation-message" }, this.getFileValidationMessage(e, t)));
  }
  /**
   * @hidden
   */
  renderFileDetails(e) {
    const s = x(this).toLanguageString(N, g[N]);
    return /* @__PURE__ */ l.createElement("span", { className: "k-file-info", key: "2" }, /* @__PURE__ */ l.createElement("span", { className: "k-file-name", title: e.name }, e.name), e.progress !== 100 ? /* @__PURE__ */ l.createElement("span", { className: "k-file-size" }, I.getTotalFilesSizeMessage([e])) : /* @__PURE__ */ l.createElement("span", { className: "k-file-validation-message" }, s));
  }
  /**
   * @hidden
   */
  render() {
    const { files: e, ...t } = this.props, s = e[0], [, o, i, a] = I.getFileStatus([s]), r = !a && !o && !i;
    return /* @__PURE__ */ l.createElement(
      "div",
      {
        className: F(
          "k-file-single"
        )
      },
      r && /* @__PURE__ */ l.createElement(he, { value: s.progress || 0 }),
      /* @__PURE__ */ l.createElement("span", { className: "k-file-icon-wrapper", key: "1" }, /* @__PURE__ */ l.createElement(B, { className: "k-file-icon", ...this.getFileExtensionIcon(s), size: "xxlarge" }), /* @__PURE__ */ l.createElement("span", { className: "k-file-state" })),
      a || i ? this.renderValidationError(s, i) : this.renderFileDetails(s),
      /* @__PURE__ */ l.createElement(
        se,
        {
          uid: s.uid,
          status: s.status,
          progress: s.progress,
          ...t
        }
      )
    );
  }
}
U(Ce);
class Ie extends l.Component {
  constructor() {
    super(...arguments), this.mapFiles = () => {
      const { files: e } = this.props;
      return e.map((t) => /* @__PURE__ */ l.createElement("span", { key: t.name, className: "k-file-info" }, /* @__PURE__ */ l.createElement("span", { className: "k-file-name", title: t.name }, t.name), I.fileHasValidationErrors(t) ? /* @__PURE__ */ l.createElement("span", { className: "k-file-validation-message" }, this.getFileValidationMessage(t)) : /* @__PURE__ */ l.createElement("span", { key: `${t.name}-size`, className: "k-file-size" }, I.getTotalFilesSizeMessage([t]))));
    }, this.progress = () => {
      const { files: e } = this.props;
      let t = 0;
      return e.forEach((s) => {
        t += s.progress || 0;
      }), t / e.length;
    };
  }
  /**
   * @hidden
   */
  getFileValidationMessage(e) {
    const t = x(this);
    let s = "";
    if (e.validationErrors && e.validationErrors.length > 0) {
      const o = `upload.${e.validationErrors[0]}`;
      s = t.toLanguageString(o, g[o]);
    }
    return s;
  }
  render() {
    const { files: e, ...t } = this.props, [, s, o, i] = I.getFileStatus(e), a = x(this), r = a.toLanguageString(W, g[W]), d = a.toLanguageString(J, g[J]), f = a.toLanguageString(O, g[O]), p = a.toLanguageString(N, g[N]), h = this.progress();
    return /* @__PURE__ */ l.createElement(
      "div",
      {
        className: F(
          "k-file-multiple"
        )
      },
      !i && !s && !o && /* @__PURE__ */ l.createElement(he, { value: h || 0 }),
      /* @__PURE__ */ l.createElement("span", { className: "k-file-icon-wrapper" }, /* @__PURE__ */ l.createElement(B, { className: "k-file-icon", name: "copy", icon: Qe, size: "xxlarge" })),
      /* @__PURE__ */ l.createElement("span", { className: "k-multiple-files-wrapper" }, this.mapFiles(), o ? /* @__PURE__ */ l.createElement("span", { className: "k-file-validation-message" }, `${e.length} ${f}`) : h !== 100 ? /* @__PURE__ */ l.createElement("span", { className: "k-file-summary" }, `${r}: ${e.length} ${d}, ${I.getTotalFilesSizeMessage(e)}`) : /* @__PURE__ */ l.createElement("span", { className: "k-file-summary k-text-success" }, `${e.length} ${p}`)),
      /* @__PURE__ */ l.createElement(
        se,
        {
          uid: e[0].uid,
          status: e[0].status,
          progress: h,
          ...t
        }
      )
    );
  }
}
U(Ie);
class ft extends l.Component {
  constructor() {
    super(...arguments), this._element = null, this.onClick = () => {
      this.props.onClick.call(void 0, this.props.index);
    };
  }
  componentDidUpdate() {
    const { navigationIndex: e, index: t } = this.props, s = de(document);
    e === t && this._element && s !== this._element && this._element.focus();
  }
  render() {
    const {
      files: e,
      async: t,
      disabled: s,
      navigationIndex: o,
      index: i,
      listItemUI: a,
      onCancel: r,
      onRemove: d,
      onRetry: f
    } = this.props, p = e[0], h = p.status === u.Uploaded || p.status === u.Initial, m = F(
      "k-file",
      I.filesHaveValidationErrors(e) ? "k-file-error k-file-invalid" : "",
      p.status === u.UploadFailed || p.status === u.RemoveFailed ? "k-file-error" : "",
      p.status === u.Uploading ? "k-file-progress" : "",
      h ? "k-file-success" : "",
      o === i ? "k-focus" : ""
    ), S = {
      async: t,
      disabled: s,
      onCancel: r,
      onRemove: d,
      onRetry: f
    };
    let R = a || (e.length === 1 ? Ce : Ie);
    return /* @__PURE__ */ l.createElement(
      "li",
      {
        ref: (_) => this._element = _,
        className: m,
        "data-uid": p.uid,
        tabIndex: -1,
        onClick: this.onClick
      },
      /* @__PURE__ */ l.createElement(R, { files: e, ...S })
    );
  }
}
class gt extends l.Component {
  mapListGroups() {
    const { groupedFiles: e, navigationIndex: t, ...s } = this.props;
    return Object.keys(e).map((o, i) => {
      const a = e[o];
      return /* @__PURE__ */ l.createElement(
        ft,
        {
          key: o,
          files: a,
          index: i,
          navigationIndex: t,
          ...s
        }
      );
    });
  }
  render() {
    const e = F(
      "k-upload-files",
      "k-reset"
    );
    return /* @__PURE__ */ l.createElement("ul", { className: e }, this.mapListGroups());
  }
}
const vt = /(chrome)[ \/]([\w.]+)/i, Et = /(webkit)[ \/]([\w.]+)/i;
class xe extends l.Component {
  constructor() {
    super(...arguments), this._input = null, this.onMouseDown = (e) => {
      this.props.onMouseDown && this.props.onMouseDown(e);
    }, this.onAdd = () => {
      const e = navigator.userAgent, t = this._input;
      t && (this.props.onAdd && t.files && this.props.onAdd.call(void 0, t.files), !e.match(vt) && e.match(Et) || (t.type = "", t.type = "file"));
    };
  }
  get actionElement() {
    return this._input;
  }
  render() {
    const { multiple: e, async: t, disabled: s, accept: o, hasFiles: i, ariaLabelledBy: a, ariaDescribedBy: r, id: d } = this.props, f = x(this), p = i ? fe : ge, h = f.toLanguageString(p, g[p]), m = f.toLanguageString(w, g[w]);
    return /* @__PURE__ */ l.createElement(
      "input",
      {
        id: d,
        ref: (S) => this._input = S,
        className: "k-hidden",
        autoComplete: "off",
        name: t.saveField,
        accept: o,
        type: "file",
        multiple: e,
        disabled: s,
        onChange: this.onAdd,
        onMouseDown: this.onMouseDown,
        title: h,
        "aria-label": a !== void 0 ? void 0 : m,
        "aria-labelledby": a,
        "aria-describedby": r
      }
    );
  }
}
U(xe);
const Ft = (n) => /* @__PURE__ */ l.createElement("span", { "aria-hidden": !0 }, n.message);
class Se extends l.Component {
  constructor() {
    super(...arguments), this._element = null, this._uploadInput = null, this.focus = () => {
      this._element && this._element.focus();
    }, this.onClick = () => {
      this.actionElement && this.actionElement.click(), this.props.onClick.call(void 0, this.props.addButtonIndex);
    }, this.onInputMouseDown = (e) => {
      this._element && (e.preventDefault(), this._element.focus());
    };
  }
  get actionElement() {
    if (this._uploadInput)
      return this._uploadInput.actionElement;
  }
  componentDidUpdate(e) {
    const { navigationIndex: t, addButtonIndex: s, notFocusedIndex: o } = this.props;
    t !== e.navigationIndex && e.navigationIndex !== o && t === s && this._element && this._element.focus();
  }
  render() {
    const { navigationIndex: e, addButtonIndex: t, tabIndex: s, id: o, selectMessageUI: i, ...a } = this.props, d = x(this).toLanguageString(w, g[w]), f = i || Ft;
    return /* @__PURE__ */ l.createElement("div", { className: "k-upload-button-wrap" }, /* @__PURE__ */ l.createElement(
      j,
      {
        type: "button",
        id: o,
        className: F(
          "k-upload-button",
          e === t ? "k-focus" : ""
        ),
        themeColor: "base",
        tabIndex: s,
        onClick: this.onClick,
        "aria-label": d
      },
      /* @__PURE__ */ l.createElement(f, { message: d })
    ), /* @__PURE__ */ l.createElement(
      xe,
      {
        id: o,
        ...a,
        onMouseDown: this.onInputMouseDown,
        ref: (p) => this._uploadInput = p
      }
    ));
  }
}
U(Se);
class ye extends l.Component {
  constructor() {
    super(...arguments), this._uploadElement = null, this._clearElement = null, this.onClearClick = () => {
      this.props.disabled || this.props.onClear && this.props.onClear.call(void 0);
    }, this.onUploadClick = () => {
      this.props.disabled || (this.props.onClick.call(void 0, this.props.uploadButtonIndex), this.props.onUpload && this.props.onUpload.call(void 0));
    };
  }
  componentDidUpdate(e) {
    const { navigationIndex: t, clearButtonIndex: s, uploadButtonIndex: o } = this.props;
    t !== e.navigationIndex && (t === s && this._clearElement && this._clearElement.focus(), t === o && this._uploadElement && this._uploadElement.focus());
  }
  render() {
    const { disabled: e, navigationIndex: t, clearButtonIndex: s, uploadButtonIndex: o, actionsLayout: i } = this.props, a = x(this), r = F(
      "k-actions",
      "k-hstack",
      {
        "k-justify-content-start": i === "start",
        "k-justify-content-center": i === "center",
        "k-justify-content-end": i === "end",
        "k-justify-content-stretch": i === "stretched"
      }
    ), d = F(
      "k-button k-button-md k-rounded-md k-button-solid k-button-solid-base",
      "k-clear-selected",
      e ? "k-disabled" : "",
      t === s ? "k-focus" : ""
    ), f = F(
      "k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary",
      "k-primary",
      "k-upload-selected",
      e ? "k-disabled" : "",
      t === o ? "k-focus" : ""
    );
    return /* @__PURE__ */ l.createElement("div", { className: r }, /* @__PURE__ */ l.createElement(
      "button",
      {
        ref: (p) => this._clearElement = p,
        type: "button",
        className: d,
        tabIndex: -1,
        onClick: this.onClearClick
      },
      a.toLanguageString(V, g[V])
    ), /* @__PURE__ */ l.createElement(
      "button",
      {
        ref: (p) => this._uploadElement = p,
        type: "button",
        className: f,
        tabIndex: -1,
        onClick: this.onUploadClick
      },
      a.toLanguageString(X, g[X])
    ));
  }
}
U(ye);
class ke extends l.Component {
  render() {
    const { isUploading: e, isUploaded: t, isUploadFailed: s } = this.props, o = F(
      "k-upload-status"
    ), i = !e && !s && t ? "check" : !e && s ? "exclamation-circle" : e ? "upload" : "", a = !e && !s && t ? { icon: Ye } : !e && s ? { icon: et } : e ? { icon: me } : {};
    let r = "";
    const d = x(this);
    return e ? r = d.toLanguageString(Z, g[Z]) : (t || s) && (r = d.toLanguageString(G, g[G])), /* @__PURE__ */ l.createElement("div", { className: o }, /* @__PURE__ */ l.createElement(B, { name: i, ...a }), r);
  }
}
U(ke);
const H = 100;
class Ue extends l.Component {
  constructor() {
    super(...arguments), this._lastDocumentDragOver = null, this._lastElementDragOver = null, this._documentActive = !1, this._elementActive = !1, this.onDocumentDragEnter = () => {
      if (!this.documentActive) {
        this.documentActive = !0;
        const e = () => {
          this.isDragOver(this._lastDocumentDragOver) && (this.documentActive = !1, clearInterval(this._documentInterval), this._documentInterval = null, this._lastDocumentDragOver = null);
        };
        this._documentInterval = setInterval(e, H);
      }
    }, this.onDocumentDragOver = () => {
      this._lastDocumentDragOver = /* @__PURE__ */ new Date();
    }, this.onElementDragEnter = () => {
      if (!this.elementActive) {
        this.elementActive = !0;
        const e = () => {
          this.isDragOver(this._lastElementDragOver) && (this.elementActive = !1, clearInterval(this._elementInterval), this._elementInterval = null, this._lastElementDragOver = null);
        };
        this._elementInterval = setInterval(e, H);
      }
    }, this.onElementDragOver = (e) => {
      e.preventDefault(), this._lastElementDragOver = /* @__PURE__ */ new Date();
    }, this.onDrop = (e) => {
      e.preventDefault();
      let t = e.dataTransfer.files;
      t.length > 0 && !this.props.disabled && this.props.onAdd && (this.props.multiple || t.length <= 1) && this.props.onAdd.call(void 0, t);
    }, this.isDragOver = (e) => (/* @__PURE__ */ new Date()).getTime() - (e || /* @__PURE__ */ new Date()).getTime() > H;
  }
  get documentActive() {
    return this._documentActive;
  }
  set documentActive(e) {
    const t = this.documentActive;
    this._documentActive = e, e !== t && this.forceUpdate();
  }
  get elementActive() {
    return this._elementActive;
  }
  set elementActive(e) {
    const t = this._elementActive;
    this._elementActive = e, e !== t && this.setState({});
  }
  componentDidMount() {
    document.addEventListener("dragenter", this.onDocumentDragEnter), document.addEventListener("dragover", this.onDocumentDragOver);
  }
  componentWillUnmount() {
    document.removeEventListener("dragenter", this.onDocumentDragEnter), document.removeEventListener("dragover", this.onDocumentDragOver);
  }
  render() {
    const { addButtonComponent: e, fileGroup: t } = this.props, o = x(this).toLanguageString(K, g[K]), i = F(
      "k-dropzone k-upload-dropzone",
      this.documentActive ? "k-dropzone-active" : "",
      this.elementActive ? "k-dropzone-hovered" : ""
    ), [a, r, d, f] = I.getFileStatus(t), p = F(
      "k-dropzone-hint",
      {
        // Unsure about that, since it hides the "Drop Files Message" when we remove all uploaded components.
        // 'k-hidden': this.isDragged && !this.elementActive
      }
    );
    return /* @__PURE__ */ l.createElement(
      "div",
      {
        className: i,
        onDrop: this.onDrop,
        onDragEnter: this.onElementDragEnter,
        onDragOver: this.onElementDragOver
      },
      e,
      a || r || d || f ? /* @__PURE__ */ l.createElement(ke, { isUploading: a, isUploaded: r, isUploadFailed: d }) : /* @__PURE__ */ l.createElement("div", { className: p }, o)
    );
  }
}
U(Ue);
const Ct = -1;
class be extends l.Component {
  constructor() {
    super(...arguments), this._container = null, this._uploadAddButton = null, this.focus = () => {
      if (this._uploadAddButton)
        return this._uploadAddButton.focus();
    }, this.onAdd = (e) => {
      this.props.onAdd && this.props.onAdd.call(void 0, e);
    }, this.onRetry = (e) => {
      this.props.onRetry && this.props.onRetry.call(void 0, e);
    }, this.onCancel = (e) => {
      this.props.onCancel && this.props.onCancel.call(void 0, e);
    }, this.onClear = () => {
      this.props.onClear && this.props.onClear.call(void 0);
    }, this.onUpload = () => {
      this.props.onUpload && this.props.onUpload.call(void 0);
    }, this.onRemove = (e) => {
      this.props.onRemove && this.props.onRemove.call(void 0, e);
    }, this.onKeyDown = (e) => {
      this.props.onKeyDown && this.props.onKeyDown.call(void 0, e, this.isRtl);
    }, this.onFocus = (e) => {
      this.props.onFocus && this.props.onFocus.call(void 0, e);
    }, this.onBlur = (e) => {
      this.props.onBlur && this.props.onBlur.call(void 0, e);
    }, this.onClick = (e) => {
      this.props.onClick && this.props.onClick.call(void 0, e);
    };
  }
  get async() {
    const {
      autoUpload: e,
      batch: t,
      withCredentials: s,
      saveField: o,
      saveHeaders: i,
      saveMethod: a,
      saveUrl: r,
      responseType: d,
      removeField: f,
      removeHeaders: p,
      removeMethod: h,
      removeUrl: m
    } = this.props;
    return {
      autoUpload: e,
      batch: t,
      withCredentials: s,
      saveField: o,
      saveHeaders: i,
      saveMethod: a,
      saveUrl: r,
      responseType: d,
      removeField: f,
      removeHeaders: p,
      removeMethod: h,
      removeUrl: m
    };
  }
  get groupsCount() {
    return Object.keys(this.props.groupedFiles).length;
  }
  get lastGroupIndex() {
    return this.groupsCount - 1;
  }
  get addButtonIndex() {
    return Ct;
  }
  get clearButtonIndex() {
    return this.lastGroupIndex + 1;
  }
  get uploadButtonIndex() {
    return this.lastGroupIndex + 2;
  }
  get isRtl() {
    return this._container && getComputedStyle(this._container).direction === "rtl" || !1;
  }
  /**
   * @hidden
   */
  get actionElement() {
    if (this._uploadAddButton)
      return this._uploadAddButton.actionElement;
  }
  /**
   * @hidden
   */
  render() {
    const {
      multiple: e,
      disabled: t,
      tabIndex: s,
      accept: o,
      showFileList: i,
      groupedFiles: a,
      navigationIndex: r,
      showActionButtons: d,
      actionsLayout: f,
      notFocusedIndex: p,
      listItemUI: h,
      id: m,
      ariaLabelledBy: S,
      ariaDescribedBy: R,
      selectMessageUI: _
    } = this.props, z = F(
      "k-upload",
      this.props.className,
      t ? "k-disabled" : ""
    ), M = /* @__PURE__ */ l.createElement(
      Se,
      {
        id: m,
        ariaLabelledBy: S,
        ariaDescribedBy: R,
        ref: (A) => this._uploadAddButton = A,
        accept: o,
        async: this.async,
        addButtonIndex: this.addButtonIndex,
        navigationIndex: r,
        notFocusedIndex: p,
        tabIndex: s,
        multiple: e,
        disabled: t,
        hasFiles: a ? Object.keys(a).length > 0 : !1,
        selectMessageUI: _,
        onAdd: this.onAdd,
        onClick: this.onClick
      }
    );
    return /* @__PURE__ */ l.createElement(
      "div",
      {
        ref: (A) => this._container = A,
        className: z,
        onKeyDown: this.onKeyDown,
        onFocus: this.onFocus,
        onBlur: this.onBlur
      },
      /* @__PURE__ */ l.createElement(
        Ue,
        {
          addButtonComponent: M,
          fileGroup: a,
          disabled: t,
          multiple: e,
          onAdd: this.onAdd
        }
      ),
      i ? /* @__PURE__ */ l.createElement(
        gt,
        {
          groupedFiles: a,
          disabled: t,
          async: this.async,
          navigationIndex: r,
          listItemUI: h,
          onCancel: this.onCancel,
          onRemove: this.onRemove,
          onRetry: this.onRetry,
          onClick: this.onClick
        }
      ) : void 0,
      d ? /* @__PURE__ */ l.createElement(
        ye,
        {
          disabled: t,
          navigationIndex: r,
          clearButtonIndex: this.clearButtonIndex,
          uploadButtonIndex: this.uploadButtonIndex,
          actionsLayout: f,
          onUpload: this.onUpload,
          onClear: this.onClear,
          onClick: this.onClick
        }
      ) : void 0
    );
  }
}
be.defaultProps = {
  disabled: !1,
  groupedFiles: {},
  multiple: !0,
  actionsLayout: "end"
};
const b = -2, k = -1;
class It extends l.Component {
  constructor(e) {
    super(e), this._uploadUI = null, this.focus = () => {
      this._uploadUI && this._uploadUI.focus();
    }, this.onKeyDown = (t, s) => {
      const o = this.navIndex, i = Object.keys(this.props.groupedFiles), a = i.length - 1, r = this.props.autoUpload || i.length === 0 ? a : a + 1, d = a + 1, f = d + 1, p = o === b ? k : o;
      let h = o;
      switch (t.keyCode) {
        case y.up:
          o > -1 && (h = p - 1);
          break;
        case y.down:
          o < r && (h = p + 1);
          break;
        case y.left:
          s ? o === d && (h = p + 1) : o === f && (h = p - 1);
          break;
        case y.right:
          s ? o === f && (h = p - 1) : o === d && (h = p + 1);
          break;
        case y.enter:
          if (o === k || o === b) {
            const m = de(document);
            this.actionElement && Be && (m == null ? void 0 : m.className.indexOf("k-upload-button")) === -1 && this.actionElement.click();
          }
          o >= 0 && o <= a && this.onRetry(i[o]);
          break;
        case y.space:
          (o === k || o === b) && this.actionElement && this.actionElement.click(), t.preventDefault();
          break;
        case y.tab:
          h = b;
          break;
        case y.delete:
          o >= 0 && o <= a && (h = p - 1, this.onRemove(i[o]));
          break;
        case y.esc:
          o >= 0 && o <= a && (h = p - 1, this.onCancel(i[o]));
          break;
      }
      this.navIndex = h;
    }, this.onCancel = (t) => {
      this.props.onCancel && this.props.onCancel.call(void 0, t);
    }, this.onClear = () => {
      this.navIndex = k, this.props.onClear && this.props.onClear.call(void 0);
    }, this.onUpload = () => {
      this.navIndex = k, this.props.onUpload && this.props.onUpload.call(void 0);
    }, this.onRetry = (t) => {
      this.props.onRetry && this.props.onRetry.call(void 0, t);
    }, this.onRemove = (t) => {
      this.navIndex = this.navIndex > k ? this.navIndex - 1 : k, this.props.onRemove && this.props.onRemove.call(void 0, t);
    }, this.onAdd = (t) => {
      this.navIndex = k, this.props.onAdd && this.props.onAdd.call(void 0, t);
    }, this.onClick = (t) => {
      this.navIndex = t;
    }, this.onFocus = () => {
      this._blurTimeout && (clearTimeout(this._blurTimeout), this._blurTimeout = void 0);
    }, this.onBlurTimeout = () => {
      this.navIndex = b, this._blurTimeout = void 0;
    }, this.onBlur = () => {
      clearTimeout(this._blurTimeout), this._blurTimeout = window.setTimeout(this.onBlurTimeout);
    }, this._navIndex = b;
  }
  get navIndex() {
    return this._navIndex;
  }
  set navIndex(e) {
    const t = this.navIndex;
    this._navIndex = e, e !== t && this.forceUpdate();
  }
  get actionElement() {
    if (this._uploadUI)
      return this._uploadUI.actionElement;
  }
  componentDidUpdate(e) {
    const t = Object.keys(e.groupedFiles).length, s = Object.keys(this.props.groupedFiles).length;
    t > s && this.navIndex > k && (this.navIndex = this.navIndex - (t - s));
  }
  render() {
    const { onClear: e, onRemove: t, onRetry: s, onCancel: o, onUpload: i, onAdd: a, ...r } = this.props;
    return /* @__PURE__ */ l.createElement(
      be,
      {
        ref: (d) => this._uploadUI = d,
        className: this.props.className,
        onKeyDown: this.onKeyDown,
        navigationIndex: this.navIndex,
        notFocusedIndex: b,
        onAdd: this.onAdd,
        onClear: this.onClear,
        onUpload: this.onUpload,
        onRemove: this.onRemove,
        onRetry: this.onRetry,
        onCancel: this.onCancel,
        onClick: this.onClick,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        ...r
      }
    );
  }
}
const xt = (n) => (n || []).map((e) => ({
  ...e
})), De = (n, e) => {
  e.push(n);
}, St = (n, e) => {
  n.forEach((t) => De(t, e));
}, yt = (n) => {
  const e = {};
  return n.forEach((t) => {
    e[t.uid] ? e[t.uid].push(t) : e[t.uid] = [t];
  }), e;
}, kt = (n) => {
  let e = {};
  return T(n, (t, s) => {
    let o = !0;
    t.forEach((i) => {
      (i.status !== u.Selected || i.validationErrors && i.validationErrors.length > 0) && (o = !1);
    }), o && (e[s] = t);
  }), e;
}, Ut = (n, e) => {
  T(n, (t) => {
    t.forEach((s) => {
      s.status = e;
    });
  });
}, bt = (n) => {
  let e = [];
  return T(n, (t) => {
    e.push.apply(e, t);
  }), e;
}, T = (n, e) => {
  Object.keys(n).forEach((t) => {
    e(n[t], t);
  });
}, v = {
  copyState: xt,
  addMany: St,
  add: De,
  groupFilesByUid: yt,
  filesForUpload: kt,
  setFilesStatus: Ut,
  flatFileGroup: bt,
  groupForEach: T
}, oe = (n, e) => {
  Object.keys(e).forEach((t) => {
    n.append(t, e[t]);
  });
}, Dt = (n, e, t) => {
  let s = new FormData();
  return oe(s, t), n.forEach((o) => {
    const i = o.getRawFile ? o.getRawFile() : "";
    i ? s.append(e, i, o.name) : s.append(e, i);
  }), s;
}, Rt = (n, e, t) => {
  let s = new FormData();
  return oe(s, t), n.forEach((o) => {
    s.append(e, o);
  }), s;
}, _t = (n, e) => ({
  headers: n,
  responseType: e.responseType,
  withCredentials: e.withCredentials
}), At = (n) => {
  let e = {};
  return Object.keys(n).forEach((t) => {
    e[t] = n[t];
  }), e;
}, wt = (n) => {
  const { data: e, config: t, ...s } = n;
  return {
    response: e,
    ...s
  };
}, C = {
  populateClientFormData: oe,
  populateUploadFormData: Dt,
  populateRemoveFormData: Rt,
  populateRequestOptions: _t,
  cloneRequestHeaders: At,
  convertAxiosResponse: wt
}, ae = "invalidMaxFileSize", le = "invalidMinFileSize", re = "invalidFileExtension", Nt = (n, e) => {
  e.length > 0 && e.indexOf((n.extension || "").toLowerCase()) < 0 && (n.validationErrors = n.validationErrors || [], n.validationErrors.indexOf(re) < 0 && n.validationErrors.push(re));
}, Ot = (n, e, t) => {
  e !== 0 && (n.size || 0) < e && (n.validationErrors = n.validationErrors || [], n.validationErrors.indexOf(le) < 0 && n.validationErrors.push(le)), t !== 0 && (n.size || 0) > t && (n.validationErrors = n.validationErrors || [], n.validationErrors.indexOf(ae) < 0 && n.validationErrors.push(ae));
}, Bt = (n) => n.map((t) => (t.substring(0, 1) === "." ? t : "." + t).toLowerCase()), Tt = (n, e) => {
  const t = Bt(e.allowedExtensions || []), s = e.maxFileSize || 0, o = e.minFileSize || 0;
  let i;
  for (i = 0; i < n.length; i++)
    Nt(n[i], t), Ot(n[i], o, s);
}, zt = {
  validateFiles: Tt
}, Re = {
  name: "@progress/kendo-react-upload",
  productName: "KendoReact",
  productCodes: ["KENDOUIREACT", "KENDOUICOMPLETE"],
  publishDate: 1702644823,
  version: "",
  licensingDocsUrl: "https://www.telerik.com/kendo-react-ui/components/my-license/"
};
class _e extends l.Component {
  constructor(e) {
    super(e), this._httpSubscriptions = {}, this._uploadNavigation = null, this.focus = () => {
      this._uploadNavigation && this._uploadNavigation.focus();
    }, this.triggerUpload = () => {
      this.onUpload();
    }, this.uploadFiles = (t) => {
      const s = this.async;
      v.setFilesStatus(t, u.Uploading), v.groupForEach(t, (o, i) => {
        const a = C.cloneRequestHeaders(s.saveHeaders || {}), d = {
          target: this,
          files: o,
          headers: a,
          additionalData: {}
        };
        this.props.onBeforeUpload && this.props.onBeforeUpload.call(void 0, d);
        const f = C.populateRequestOptions(d.headers, this.async), p = C.populateUploadFormData(
          o,
          s.saveField,
          d.additionalData
        );
        if (this.isCustomSave)
          this.props.saveUrl(o, { formData: p, requestOptions: f }, this.onUploadProgress).then((h) => this.onUploadSuccess(h.uid)).catch((h) => this.onUploadError(h.uid));
        else {
          const h = L.CancelToken.source();
          this._httpSubscriptions[i] = h, L({
            method: s.saveMethod,
            url: s.saveUrl,
            data: p,
            cancelToken: h.token,
            ...f,
            onUploadProgress: (m) => this.onUploadProgress(i, m)
          }).then((m) => this.onUploadSuccess(i, m)).catch((m) => this.onUploadError(i, m));
        }
      });
    }, this.removeFiles = (t) => {
      const s = this.async;
      v.groupForEach(t, (o, i) => {
        const a = C.cloneRequestHeaders(s.removeHeaders || {}), d = {
          target: this,
          files: o,
          headers: a,
          additionalData: {}
        };
        this.props.onBeforeRemove && this.props.onBeforeRemove.call(void 0, d);
        const f = o.map((m) => m.name), p = C.populateRequestOptions(d.headers, this.async), h = C.populateRemoveFormData(
          f,
          s.removeField,
          d.additionalData
        );
        this.isCustomRemove ? this.props.removeUrl(o, { formData: h, requestOptions: p }).then((m) => this.onRemoveSuccess(m.uid)).catch((m) => this.onRemoveError(m.uid)) : L({
          method: s.removeMethod,
          url: s.removeUrl,
          data: h,
          ...p
        }).then((m) => this.onRemoveSuccess(i, m)).catch((m) => this.onRemoveError(i, m));
      });
    }, this.onUpload = () => {
      const t = this.fileStateCopy, s = v.groupFilesByUid(t), o = v.filesForUpload(s);
      this.uploadFiles(o);
      const i = () => {
        if (this.props.onStatusChange) {
          const a = {
            target: this,
            newState: t,
            affectedFiles: v.flatFileGroup(o)
          };
          this.props.onStatusChange.call(void 0, a);
        }
      };
      this.isControlled ? i() : this.setState({ files: t }, i);
    }, this.onAdd = (t) => {
      let s = I.getAllFileInfo(t), o;
      if (s = I.assignGuidToFiles(s, this.async.batch), zt.validateFiles(s, this.props.restrictions), this.props.multiple ? o = this.fileStateCopy : o = [], v.addMany(s, o), this.async.autoUpload) {
        const a = v.groupFilesByUid(o);
        this.uploadFiles(v.filesForUpload(a));
      }
      const i = () => {
        if (this.props.onAdd) {
          const a = {
            target: this,
            newState: o,
            affectedFiles: s
          };
          this.props.onAdd.call(void 0, a);
        }
      };
      this.isControlled ? i() : this.setState({ files: o }, i);
    }, this.onUploadProgress = (t, s) => {
      const o = Math.round(100 * s.loaded / (s.total || 0)) || 0, i = this.fileStateCopy, a = i.filter((d) => d.uid === t);
      if (!a.length)
        return;
      a.forEach((d) => {
        d.progress = o;
      });
      const r = () => {
        if (this.props.onProgress) {
          const d = {
            target: this,
            newState: i,
            affectedFiles: a
          };
          this.props.onProgress.call(void 0, d);
        }
      };
      this.isControlled ? r() : this.setState({ files: i }, r);
    }, this.onUploadSuccess = (t, s) => {
      const o = this.fileStateCopy, i = o.filter((r) => r.uid === t);
      i.forEach((r) => {
        r.status = u.Uploaded;
      }), delete this._httpSubscriptions[t];
      const a = () => {
        if (this.props.onStatusChange) {
          const r = {
            target: this,
            newState: o,
            affectedFiles: i,
            response: s ? C.convertAxiosResponse(s) : void 0
          };
          this.props.onStatusChange.call(void 0, r);
        }
      };
      this.isControlled ? a() : this.setState({ files: o }, a);
    }, this.onUploadError = (t, s) => {
      const o = this.fileStateCopy, i = o.filter((r) => r.uid === t);
      if (i.forEach((r) => {
        r.status = u.UploadFailed;
      }), delete this._httpSubscriptions[t], !i.length)
        return;
      const a = () => {
        if (this.props.onStatusChange) {
          const r = {
            target: this,
            newState: o,
            affectedFiles: i,
            response: s ? C.convertAxiosResponse(s) : void 0
          };
          this.props.onStatusChange.call(void 0, r);
        }
      };
      this.isControlled ? a() : this.setState({ files: o }, a);
    }, this.onRemove = (t) => {
      const s = this.fileStateCopy, o = s.filter((r) => r.uid === t), i = s.filter((r) => r.uid !== t);
      if ([
        u.Uploaded,
        u.Initial,
        u.RemoveFailed
      ].indexOf(o[0].status) > -1) {
        const r = {
          [t]: o
        };
        v.setFilesStatus(r, u.Removing), this.removeFiles(r);
        const d = () => {
          if (this.props.onStatusChange) {
            const f = {
              target: this,
              newState: s,
              affectedFiles: o
            };
            this.props.onStatusChange.call(void 0, f);
          }
        };
        this.isControlled ? d() : this.setState({ files: s }, d);
      } else {
        const r = () => {
          if (this.props.onRemove) {
            const d = {
              target: this,
              newState: i,
              affectedFiles: o
            };
            this.props.onRemove.call(void 0, d);
          }
        };
        this.isControlled ? r() : this.setState({ files: i }, r);
      }
    }, this.onRemoveSuccess = (t, s) => {
      const o = this.fileStateCopy, i = o.filter((d) => d.uid === t), a = o.filter((d) => d.uid !== t), r = () => {
        if (this.props.onRemove) {
          const d = {
            target: this,
            newState: a,
            affectedFiles: i,
            response: s ? C.convertAxiosResponse(s) : void 0
          };
          this.props.onRemove.call(void 0, d);
        }
      };
      this.isControlled ? r() : this.setState({ files: a }, r);
    }, this.onRemoveError = (t, s) => {
      const o = this.fileStateCopy, i = o.filter((r) => r.uid === t);
      i.forEach((r) => {
        r.status = u.RemoveFailed;
      });
      const a = () => {
        if (this.props.onStatusChange) {
          const r = {
            target: this,
            newState: o,
            affectedFiles: i,
            response: s ? C.convertAxiosResponse(s) : void 0
          };
          this.props.onStatusChange.call(void 0, r);
        }
      };
      this.isControlled ? a() : this.setState({ files: o }, a);
    }, this.onRetry = (t) => {
      const s = this.fileStateCopy, o = v.groupFilesByUid(s.filter((a) => a.uid === t));
      v.setFilesStatus(o, u.Uploading), this.uploadFiles(o);
      const i = () => {
        if (this.props.onStatusChange) {
          const a = {
            target: this,
            newState: s,
            affectedFiles: v.flatFileGroup(o)
          };
          this.props.onStatusChange.call(void 0, a);
        }
      };
      this.isControlled ? i() : this.setState({ files: s }, i);
    }, this.onCancel = (t) => {
      const s = this.fileStateCopy, o = s.filter((r) => r.uid !== t), i = s.filter((r) => r.uid === t);
      if (this._httpSubscriptions[t] && (this._httpSubscriptions[t].cancel(), delete this._httpSubscriptions[t]), this.props.onCancel) {
        const r = {
          target: this,
          uid: t
        };
        this.props.onCancel.call(void 0, r);
      }
      const a = () => {
        if (this.props.onRemove) {
          const r = {
            target: this,
            newState: o,
            affectedFiles: i
          };
          this.props.onRemove.call(void 0, r);
        }
      };
      this.isControlled ? a() : this.setState({ files: o }, a);
    }, this.onClear = () => {
      if (!this.files.length)
        return;
      Object.keys(this._httpSubscriptions).forEach((s) => {
        this._httpSubscriptions[s].cancel();
      }), this._httpSubscriptions = {};
      const t = () => {
        if (this.props.onRemove) {
          const s = {
            target: this,
            newState: [],
            affectedFiles: this.fileStateCopy
          };
          this.props.onRemove.call(void 0, s);
        }
      };
      this.isControlled ? t() : this.setState({ files: [] }, t);
    }, pe(Re), this.state = {
      files: e.defaultFiles || []
    };
  }
  get async() {
    const {
      autoUpload: e,
      batch: t,
      removeField: s,
      removeHeaders: o,
      removeMethod: i,
      removeUrl: a,
      responseType: r,
      saveField: d,
      saveHeaders: f,
      saveMethod: p,
      saveUrl: h,
      withCredentials: m
    } = this.props;
    return {
      autoUpload: e,
      batch: t,
      removeField: s,
      removeHeaders: o,
      removeMethod: i,
      removeUrl: a,
      responseType: r,
      saveField: d,
      saveHeaders: f,
      saveMethod: p,
      saveUrl: h,
      withCredentials: m
    };
  }
  get files() {
    return (this.isControlled ? this.props.files : this.state.files) || [];
  }
  get isControlled() {
    return !this.props.defaultFiles;
  }
  get isCustomSave() {
    return this.props.saveUrl && typeof this.props.saveUrl == "function";
  }
  get isCustomRemove() {
    return this.props.removeUrl && typeof this.props.removeUrl == "function";
  }
  get fileStateCopy() {
    return this.isControlled ? v.copyState(this.props.files) : v.copyState(this.state.files);
  }
  /**
   * @hidden
   */
  get actionElement() {
    if (this._uploadNavigation)
      return this._uploadNavigation.actionElement;
  }
  /**
   * @hidden
   */
  render() {
    const {
      showFileList: e,
      onAdd: t,
      onRemove: s,
      onCancel: o,
      autoUpload: i,
      showActionButtons: a,
      actionsLayout: r,
      tabIndex: d,
      disabled: f,
      ...p
    } = this.props, h = v.groupFilesByUid(this.files), m = v.filesForUpload(h);
    return /* @__PURE__ */ l.createElement(
      It,
      {
        groupedFiles: h,
        className: this.props.className,
        showFileList: e && !!Object.keys(h).length,
        showActionButtons: a && !i && !!Object.keys(m).length,
        actionsLayout: r,
        autoUpload: i,
        disabled: f,
        onAdd: this.onAdd,
        onRemove: this.onRemove,
        onClear: this.onClear,
        onUpload: this.onUpload,
        onRetry: this.onRetry,
        onCancel: this.onCancel,
        tabIndex: ue(d, f),
        ref: (S) => this._uploadNavigation = S,
        ...p
      }
    );
  }
}
_e.defaultProps = {
  autoUpload: !0,
  batch: !1,
  removeField: "fileNames",
  removeHeaders: {},
  removeMethod: "POST",
  removeUrl: "",
  responseType: "json",
  saveField: "files",
  saveHeaders: {},
  saveMethod: "POST",
  saveUrl: "",
  withCredentials: !0,
  restrictions: {
    allowedExtensions: [],
    maxFileSize: 0,
    minFileSize: 0
  },
  multiple: !0,
  showFileList: !0,
  showActionButtons: !0,
  actionsLayout: "end",
  disabled: !1
};
_e.propTypes = {
  autoUpload: c.bool,
  batch: c.bool,
  withCredentials: c.bool,
  saveField: c.string,
  saveHeaders: c.object,
  saveMethod: c.string,
  saveUrl: c.oneOfType([c.string, c.func]),
  responseType: c.oneOf(["arraybuffer", "blob", "json", "text"]),
  removeField: c.string,
  removeHeaders: c.object,
  removeMethod: c.string,
  removeUrl: c.oneOfType([c.string, c.func]),
  multiple: c.bool,
  disabled: c.bool,
  showFileList: c.bool,
  showActionButtons: c.bool,
  actionsLayout: c.oneOf(["start", "center", "end", "stretched"]),
  tabIndex: c.number,
  accept: c.string,
  listItemUI: c.oneOfType([
    c.func,
    c.string,
    c.shape({ render: c.func.isRequired })
  ]),
  restrictions: c.shape({
    allowedExtensions: c.arrayOf(c.string),
    maxFileSize: c.number,
    minFileSize: c.number
  }),
  files: c.arrayOf(c.shape({
    uid: c.string,
    name: c.string,
    extension: c.string,
    size: c.number,
    validationErrors: c.arrayOf(c.string),
    status: c.oneOf([
      u.Initial,
      u.RemoveFailed,
      u.Removing,
      u.Selected,
      u.UploadFailed,
      u.Uploaded,
      u.Uploading
    ]),
    progress: c.number,
    getRawFile: c.func
  })),
  defaultFiles: c.arrayOf(c.shape({
    uid: c.string,
    name: c.string,
    extension: c.string,
    size: c.number,
    validationErrors: c.arrayOf(c.string),
    status: c.oneOf([
      u.Initial,
      u.RemoveFailed,
      u.Removing,
      u.Selected,
      u.UploadFailed,
      u.Uploaded,
      u.Uploading
    ]),
    progress: c.number,
    getRawFile: c.func
  }))
};
const ce = 100, Ae = l.forwardRef((n, e) => {
  pe(Re);
  const t = l.useRef(null), s = l.useRef(null);
  let o = l.useRef(null), i = l.useRef(!1), a = l.useRef(null);
  const { uploadRef: r } = n, d = r.current;
  let [f, p] = l.useState(!1);
  const h = l.useMemo(() => new Te("en"), []), m = ze(), S = m.toLanguageString(Q, g[Q]), [R, _] = l.useState(
    m.toLanguageString(Y, g[Y])
  ), z = n.customHint || /* @__PURE__ */ l.createElement("span", null, S), M = n.customNote || /* @__PURE__ */ l.createElement("span", null, R), A = l.useCallback(
    () => {
      s.current && s.current.focus();
    },
    [s]
  );
  l.useImperativeHandle(t, () => ({
    element: s.current,
    focus: A,
    props: n
  })), l.useImperativeHandle(e, () => t.current), l.useEffect(
    () => {
      if (d) {
        const E = d.props.restrictions.allowedExtensions;
        if (E && E.length) {
          const D = h.format(
            m.toLanguageString(ee, g[ee]),
            [
              E
            ]
          );
          _(D);
        }
      }
    },
    [d, m, h]
  );
  const ne = l.useCallback(
    (E) => (/* @__PURE__ */ new Date()).getTime() - (E || /* @__PURE__ */ new Date()).getTime() > ce,
    []
  ), we = l.useCallback(
    (E) => {
      E.preventDefault();
      let D = E.dataTransfer.files;
      D.length > 0 && !n.disabled && r && r.current && (r.current.onAdd && (E.preventDefault(), r.current.onAdd(D)), n.onDrop && n.onDrop.call(void 0, E));
    },
    [n.disabled, r, n.onDrop]
  ), Ne = l.useCallback(
    (E) => {
      if (i) {
        i.current = !0;
        const D = () => {
          ne(a.current) && (p(!1), i.current = !1, clearInterval(o.current), o.current = null, a.current = null);
        };
        o.current = setInterval(D, ce);
      }
      n.onElementDragEnter && n.onElementDragEnter.call(void 0, E);
    },
    [i, o, a, ne, n.onElementDragEnter]
  ), Oe = l.useCallback(
    (E) => {
      E.preventDefault(), a.current = /* @__PURE__ */ new Date(), p(!0), n.onElementDragOver && n.onElementDragOver.call(void 0, E);
    },
    [a, n.onElementDragOver]
  );
  return /* @__PURE__ */ l.createElement(
    "div",
    {
      ref: s,
      id: n.id,
      className: F(
        "k-external-dropzone",
        {
          "k-external-dropzone-hover": f,
          "k-disabled": n.disabled
        },
        n.className
      ),
      tabIndex: ue(n.tabIndex, n.disabled, void 0),
      onDrop: we,
      onDragEnter: Ne,
      onDragOver: Oe
    },
    /* @__PURE__ */ l.createElement(
      "div",
      {
        style: n.style,
        className: "k-dropzone-inner"
      },
      /* @__PURE__ */ l.createElement(B, { name: "upload", icon: me, className: "k-dropzone-icon", size: "xxxlarge" }),
      /* @__PURE__ */ l.createElement("span", { className: "k-dropzone-hint" }, z),
      /* @__PURE__ */ l.createElement("span", { className: "k-dropzone-note" }, M)
    )
  );
}), Mt = {
  id: c.string,
  tabIndex: c.number,
  editorRef: c.oneOfType([
    c.func,
    c.shape({ current: c.any })
  ]),
  disabled: c.bool,
  onDrop: c.func,
  onElementDragEnter: c.func,
  onElementDragOver: c.func
};
Ae.displayName = "KendoReactExternalDropZone";
Ae.propTypes = Mt;
export {
  Ae as ExternalDropZone,
  _e as Upload,
  ye as UploadActionButtons,
  Se as UploadAddButton,
  Ue as UploadDropZone,
  u as UploadFileStatus,
  xe as UploadInput,
  gt as UploadList,
  se as UploadListActionButton,
  ft as UploadListGroup,
  Ie as UploadListMultiItem,
  Ce as UploadListSingleItem,
  ke as UploadStatus,
  be as UploadUI,
  G as headerStatusUploaded,
  Z as headerStatusUploading,
  ot as invalidMaxFileSize,
  g as uploadMessages,
  w as uploadSelect,
  I as uploadUtils
};
